if (!customElements.get('gravel-calculator')) {
  class GravelCalculator extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.gravel-calc-trigger');
      this.overlay = this.querySelector('.gravel-calc-overlay');
      this.panel = this.querySelector('.gravel-calc-panel');
      this.closeBtn = this.querySelector('.gravel-calc-close');
      this.resetBtn = this.querySelector('.gravel-calc-reset');
      this.shapeBtns = this.querySelectorAll('[data-shape]');
      this.dimensionsRectangular = this.querySelector('[data-dimensions="rectangular"]');
      this.dimensionsCircular = this.querySelector('[data-dimensions="circular"]');
      this.lengthInput = this.querySelector('[data-calc-length]');
      this.widthInput = this.querySelector('[data-calc-width]');
      this.diameterInput = this.querySelector('[data-calc-diameter]');
      this.thicknessSelect = this.querySelector('[data-calc-thickness]');
      this.areaDisplay = this.querySelector('[data-calc-area-display]');
      this.resultValue = this.querySelector('[data-calc-result-value]');
      this.resultExtra = this.querySelector('[data-calc-result-extra]');
      this.currentShape = 'rectangular';
    }

    connectedCallback() {
      this.trigger.addEventListener('click', () => this.open());
      this.overlay.addEventListener('click', () => this.close());
      this.closeBtn.addEventListener('click', () => this.close());
      this.resetBtn.addEventListener('click', () => this.reset());

      this.shapeBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.setShape(btn.dataset.shape));
      });

      this.lengthInput.addEventListener('input', () => this.calculate());
      this.widthInput.addEventListener('input', () => this.calculate());
      this.diameterInput.addEventListener('input', () => this.calculate());
      this.thicknessSelect.addEventListener('change', () => this.calculate());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) {
          this.close();
        }
      });
    }

    open() {
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => {
        if (this.currentShape === 'rectangular') {
          this.lengthInput.focus();
        } else {
          this.diameterInput.focus();
        }
      }, 350);
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    setShape(shape) {
      this.currentShape = shape;
      this.shapeBtns.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.shape === shape);
      });
      this.dimensionsRectangular.style.display = shape === 'rectangular' ? '' : 'none';
      this.dimensionsCircular.style.display = shape === 'circular' ? '' : 'none';
      this.calculate();
    }

    reset() {
      this.lengthInput.value = '';
      this.widthInput.value = '';
      this.diameterInput.value = '';
      this.thicknessSelect.value = '75';
      this.setShape('rectangular');
      this.areaDisplay.innerHTML = 'Totaal oppervlak: <strong>0 m²</strong>';
      this.resultValue.textContent = '0 kg';
      this.resultExtra.textContent = '';
    }

    getArea() {
      if (this.currentShape === 'rectangular') {
        const length = parseFloat(this.lengthInput.value) || 0;
        const width = parseFloat(this.widthInput.value) || 0;
        return length * width;
      } else {
        const diameter = parseFloat(this.diameterInput.value) || 0;
        const radius = diameter / 2;
        return Math.PI * radius * radius;
      }
    }

    calculate() {
      const area = this.getArea();
      const factor = parseFloat(this.thicknessSelect.value) || 75;
      const totalKg = Math.round(area * factor);
      const totalTon = (totalKg / 1000).toFixed(1);

      this.areaDisplay.innerHTML = 'Totaal oppervlak: <strong>' + area.toFixed(1) + ' m²</strong>';
      this.resultValue.textContent = totalKg.toLocaleString('nl-NL') + ' kg';

      if (totalKg > 0) {
        this.resultExtra.textContent = totalTon + ' ton | ' + (totalKg / 1500).toFixed(1) + ' m³';
      } else {
        this.resultExtra.textContent = '';
      }
    }
  }

  customElements.define('gravel-calculator', GravelCalculator);
}
